import { render, staticRenderFns } from "./templates.vue?vue&type=template&id=1df49c76&scoped=true"
import script from "./templates.ts?vue&type=script&lang=ts&external"
export * from "./templates.ts?vue&type=script&lang=ts&external"
import style0 from "./templates.less?vue&type=style&index=0&id=1df49c76&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df49c76",
  null
  
)

export default component.exports